export const SET_KEYDOWN_KEY = 'SET_KEYDOWN_KEY'
export const SET_ACTIVE_BUTTON = 'SET_ACTIVE_BUTTON'